module.exports = __webpack_public_path__ + "img/Dark.b7cebfb8.png";